function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 1,
  fill: "#F0F0F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 11.12L4.8 8.64L3 6.16H4.37L5.63 7.92L6.88 6.16H8.26L6.45 8.64L8.26 11.12H6.88L5.63 9.36L4.37 11.12H3Z",
  fill: "#1A172A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.93547 11.12V10.19C9.36214 9.83667 9.77547 9.48667 10.1755 9.14C10.5821 8.79333 10.9421 8.45 11.2555 8.11C11.5755 7.77 11.8288 7.44 12.0155 7.12C12.2088 6.79333 12.3055 6.47667 12.3055 6.17C12.3055 5.88333 12.2255 5.63 12.0655 5.41C11.9121 5.19 11.6555 5.08 11.2955 5.08C10.9288 5.08 10.6521 5.2 10.4655 5.44C10.2788 5.68 10.1855 5.97 10.1855 6.31H8.94547C8.9588 5.79667 9.07214 5.37 9.28547 5.03C9.4988 4.68333 9.78214 4.42667 10.1355 4.26C10.4888 4.08667 10.8855 4 11.3255 4C12.0388 4 12.5921 4.19667 12.9855 4.59C13.3855 4.97667 13.5855 5.48 13.5855 6.1C13.5855 6.48667 13.4955 6.86333 13.3155 7.23C13.1421 7.59667 12.9121 7.95 12.6255 8.29C12.3388 8.63 12.0288 8.95 11.6955 9.25C11.3621 9.54333 11.0388 9.81667 10.7255 10.07H13.7555V11.12H8.93547Z",
  fill: "#1A172A"
});

function SvgX2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2);
export default __webpack_public_path__ + "static/media/x2.ce8e87b6.svg";
export { ForwardRef as ReactComponent };